import { render } from "./DicomFileUpload.vue?vue&type=template&id=f236fc22&scoped=true&ts=true"
import script from "./DicomFileUpload.vue?vue&type=script&lang=ts"
export * from "./DicomFileUpload.vue?vue&type=script&lang=ts"

import "./DicomFileUpload.vue?vue&type=style&index=0&id=f236fc22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f236fc22"]])

export default __exports__